import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import type { NotificationData } from '../../../services/notification.service';

/**
 * Triggers the Way auto-redeem success toast (hosted by LaneAutoRedeemToastComponent).
 */
@Injectable({
  providedIn: 'root',
})
export class LaneAutoRedeemToastService {
  private readonly showSubject = new Subject<NotificationData>();
  readonly show$ = this.showSubject.asObservable();

  show(notification: NotificationData): void {
    this.showSubject.next(notification);
  }
}
